import { EVENT_NAME as LibrariesToolbarCloseEventName } from '@adobe-fonts/site/events/LibrariesToolbarCloseEvent.js';

export class LibrariesToolbarClose {
  constructor(element) {
    this.element = element;
  }

  handleLibrariesToolbarCloseEvent = () => {
    this.element.checkedVariationsCount = 0;
    this.element._settingsBar.classList.remove('hide');
    this.element._variationCards.forEach(variation => variation.removeAttribute('selected'));
  };
}

export function registerEventHandlers(element) {
  const librariesToolbarMixin = new LibrariesToolbarClose(element);
  element.addEventListener(LibrariesToolbarCloseEventName, librariesToolbarMixin.handleLibrariesToolbarCloseEvent);
}
